/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { TextField, ListItemText, MenuItem, FormControl, Checkbox, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

const MenuProps = {
  disableScrollLock: true,
  PaperProps: {
    style: {
      maxHeight: 48 * 6,
      width: 250,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

function MultipleCheckboxesSelect({ options, onChange, value, ...props }) {
  const classes = useStyles();

  const handleChange = (event) => {
    const {
      target: { value: selectedValue },
    } = event;
    onChange(selectedValue);
  };

  return (
    <FormControl className={classes.multipleCheckboxesSelect}>
      <TextField
        variant="outlined"
        fullWidth
        select
        SelectProps={{
          'data-testid': 'multiple-select',
          multiple: true,
          value,
          onChange: handleChange,
          renderValue: (selected) =>
            options
              .filter((option) => selected.includes(option.value))
              .map(({ label }) => label)
              .join(', '),
          MenuProps,
        }}
        {...props}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={value.includes(option.value)} color="primary" />
            <ListItemText
              primary={
                <Typography component="span" variant="body1" classes={{ root: value.includes(option.value) ? classes.activeCheckboxLabel : classes.checkboxLabel }}>
                  {option.label}
                </Typography>
              }
            />
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}

MultipleCheckboxesSelect.propTypes = {
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.any),
  ...TextField.propTypes,
};

MultipleCheckboxesSelect.defaultProps = {
  options: [],
  onChange: () => {},
  value: [],
};

export default MultipleCheckboxesSelect;
